function f(r) {
  const e = r.filter((n) => n !== void 0);
  if (e.length !== 0)
    return e.length === 1 ? e[0] : (n) => {
      r.forEach((t) => {
        t && t(n);
      });
    };
}
export {
  f as mergeEventHandlers
};
